<script setup lang="ts">

import { computed, ref, watchEffect } from 'vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { utils } from '../../utils';

import Button from '../General/Button.vue';
import Modal from '../General/Modal.vue';
import RankingIcon from '../../assets/icons/ranking_student.svg';
import Heading from '../General/Heading.vue';

import Leaderboard from '../Class/Leaderboard.vue';
import { useClassStore } from '../../stores/class';
import { useUserStore } from '../../stores/user';
import { useSessionStore } from '../../stores';

const classStore = useClassStore();
const sessionStore = useSessionStore()
const userStore = useUserStore();
const studentRank = computed(() => classStore.rankedStudents.find((student) => student.id == userStore.userInfo?.id))
const { t } = useI18n()
const modalShow = ref<boolean>(false)

function showModal() {
    modalShow.value = true
}

watchEffect(() => {
    if (!sessionStore.teacherSession) return;
    modalShow.value = false
})
</script>

<template>
    <Button @click="showModal" color="main" type="outline" class="flex gap-5">
        <span class="flex gap-2 items-center">
            <RankingIcon class="size-5" />
            {{ utils.ordinalSuffixOf(studentRank?.rank) }}
        </span>
        <span>{{ utils.calculateTotalPoint(studentRank?.bonus_point) || 0 }} {{ t(TEXT.pts) }}</span>
    </Button>
    <Modal v-model="modalShow" size="large" :full-height="true">
        <div class="flex flex-col h-full">
            <Heading alignment="center" size="large" color="main">{{ t(TEXT.leaderboard) }}</Heading>
            <Leaderboard />
        </div>
    </Modal>
</template>